/**
 * Bulk Actions Component
 * Handles bulk operations on selected inventory items
 */

import React, { useState } from 'react';
import { TrashIcon } from '@heroicons/react/24/outline';
import axios from 'axios';

const BulkActions = ({ selectedItems, onBulkDelete, onClearSelection }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleBulkDelete = async () => {
    if (selectedItems.size === 0) return;
    
    const itemCount = selectedItems.size;
    if (!window.confirm(`Are you sure you want to delete ${itemCount} item${itemCount > 1 ? 's' : ''}?`)) {
      return;
    }

    setIsDeleting(true);
    try {
      const token = localStorage.getItem('token');
      const itemIdsArray = Array.from(selectedItems);
      
      const response = await axios.delete('/api/inventory/items/bulk/delete', {
        headers: { Authorization: `Bearer ${token}` },
        data: { itemIds: itemIdsArray }
      });

      if (response.data.success) {
        onBulkDelete?.(itemIdsArray);
        onClearSelection?.();
      } else {
        throw new Error(response.data.error || 'Failed to delete items');
      }
    } catch (error) {
      console.error('Error deleting items:', error);
      alert('Failed to delete items. Please try again.');
    } finally {
      setIsDeleting(false);
    }
  };

  if (selectedItems.size === 0) {
    return null;
  }

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 sm:p-4 mb-4">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0">
        <span className="text-sm font-medium text-blue-900">
          {selectedItems.size} item{selectedItems.size > 1 ? 's' : ''} selected
        </span>
        <div className="flex flex-col sm:flex-row gap-2 sm:space-x-2 sm:gap-0">
          <button
            onClick={handleBulkDelete}
            disabled={isDeleting}
            className="bg-red-600 hover:bg-red-700 disabled:bg-red-400 text-white px-4 py-2 sm:px-3 sm:py-1 rounded text-sm flex items-center justify-center touch-manipulation"
          >
            <TrashIcon className="h-4 w-4 mr-1" />
            {isDeleting ? 'Deleting...' : 'Delete Selected'}
          </button>
          <button
            onClick={onClearSelection}
            className="bg-gray-300 hover:bg-gray-400 text-gray-700 px-4 py-2 sm:px-3 sm:py-1 rounded text-sm touch-manipulation"
          >
            Clear Selection
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkActions;